import { useEffect, useState } from 'react';
import { AppBar } from '@carto/react-ui';
import DrawerMenu from './DrawerMenu';
import NavigationMenu from './NavigationMenu';
import UserMenu from './UserMenu';
import { styled } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import bmpoLogo from 'assets/img/BMPO_header_logo.png';
import {
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Hidden, 
  Grid, Drawer, Box 
} from '@mui/material';

import {
  Menu,
  Close,
  FolderOutlined,
  CreateNewFolderOutlined,
  SaveOutlined,
  PictureAsPdfOutlined,
  UploadOutlined,
  ViewListOutlined,
} from '@mui/icons-material';

import CustomUrbanSimIcon from 'assets/customIcons/UrbanSimIcon';
import { ROUTE_PATHS } from 'routes';
import { useAppState } from 'components/contexts/State';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: '#fff',
  boxShadow:
    '0px 1px 14px 0px rgba(0, 0, 0, 0.12), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)',
  height: '56px',
  padding: '1px 16px',
  '.MuiToolbar-root': {
    padding: '0px',
    height: '100%',
  },
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

export default function Header() {
  const { userRoleDetails } = useAppState();

  const location = useLocation();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setDrawerOpen(false);
    setMenuOpen(false);
  }, [location]);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const toggleMenu = (newOpen) => () => {
    setMenuOpen(newOpen);
  };

  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    const items = [];
    if (
      userRoleDetails &&
      userRoleDetails.resources &&
      (userRoleDetails.resources.includes('project_repo_self_view') ||
        userRoleDetails.resources.includes('project_repo_all_view'))
    ) {
      userRoleDetails.resources.includes('project_repo_create')
        ? items.push([
            {
              text: 'View projects',
              icon: (
                <FolderOutlined
                  sx={{
                    color: '#002547',
                    height: '24px !important',
                    width: '24px !important',
                  }}
                />
              ),
              action: () => {
                navigate(ROUTE_PATHS.PROJECT);
              },
              activePath: ROUTE_PATHS.PROJECT,
            },
            // {
            //   text: 'New project',
            //   icon: (
            //     <CreateNewFolderOutlined
            //       sx={{
            //         color: '#002547',
            //         height: '24px !important',
            //         width: '24px !important',
            //       }}
            //     />
            //   ),
            //   action: () => {},
            // },
          ])
        : items.push([
            {
              text: 'View projects',
              icon: (
                <FolderOutlined
                  sx={{
                    color: '#002547',
                    height: '24px !important',
                    width: '24px !important',
                  }}
                />
              ),
              action: () => {
                navigate(ROUTE_PATHS.PROJECT);
              },
              activePath: ROUTE_PATHS.PROJECT,
            },
          ]);
    }
    if (
      userRoleDetails &&
      userRoleDetails.resources &&
      (userRoleDetails.resources.includes('data_repo_self_view') ||
        userRoleDetails.resources.includes('data_repo_all_view'))
    ) {
      userRoleDetails.resources.includes('data_repo_create')
        ? items.push([
            // {
            //   text: 'Upload data',
            //   icon: (
            //     <UploadOutlined
            //       sx={{
            //         color: '#002547',
            //         height: '24px !important',
            //         width: '24px !important',
            //       }}
            //     />
            //   ),
            //   action: () => {},
            // },
            {
              text: 'Manage data',
              icon: (
                <ViewListOutlined
                  sx={{
                    color: '#002547',
                    height: '24px !important',
                    width: '24px !important',
                  }}
                />
              ),
              action: () => {
                navigate(ROUTE_PATHS.DATA);
              },
              activePath: ROUTE_PATHS.DATA,
            },
          ])
        : items.push([
            {
              text: 'Manage data',
              icon: (
                <ViewListOutlined
                  sx={{
                    color: '#002547',
                    height: '24px !important',
                    width: '24px !important',
                  }}
                />
              ),
              action: () => {
                navigate(ROUTE_PATHS.DATA);
              },
              activePath: ROUTE_PATHS.DATA,
            },
          ]);
    }
    if (
      userRoleDetails &&
      userRoleDetails.resources &&
      userRoleDetails.resources.includes('manage_urbansim')
    ) {
      items.push([
        {
          text: 'Switch to Urbansim',
          icon: (
            <CustomUrbanSimIcon
              sx={{
                color: '#002547',
                height: '24px !important',
                width: '24px !important',
              }}
            />
          ),
          action: () => {
            window.open('https://prod.urbansim.com/', '_blank');
          },
        },
      ]);
    }
    setSidebarItems(items);
  }, [userRoleDetails]);

  const DrawerList = (
    <Box sx={{ width: 250 }} role='presentation'>
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '24px 16px',
        }}
      >
        <img
          src={bmpoLogo}
          alt='BMPO'
          style={{ height: '13.54px', cursor: 'pointer' }}
          onClick={() => {
            toggleMenu(false);
            navigate(ROUTE_PATHS.HOME);
          }}
        />
        <Close
          sx={{
            color: '#002547',
            fontSize: '12px',
            height: '24px !important',
            width: '24px !important',
            cursor: 'pointer',
          }}
          onClick={toggleMenu(false)}
        ></Close>
      </div>
      {/* <div
        style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '6px 16px' }}
      >
        <span
          className='normal-text-style-3'
          style={{ color: '#0054A4', fontWeight: '600' }}
        >
          LAND USE
        </span>
        <span
          style={{ height: '16px', borderLeft: '1px solid rgba(0, 37, 71, 0.60)' }}
        ></span>
        <span
          className='normal-text-style-5'
          style={{ cursor: 'pointer' }}
          onClick={() => {
            window.open(
              'https://infrastructure-insights-pro-tmi-demo.web.app/',
              '_blank'
            );
          }}
        >
          TRAFFIC
        </span>
        <span
          style={{ height: '16px', borderLeft: '1px solid rgba(0, 37, 71, 0.60)' }}
        ></span>
        <span
          className='normal-text-style-5'
          style={{ cursor: 'pointer' }}
          onClick={() => {
            window.open(
              'https://infrastructure-insights-pro-demo-vru.web.app/',
              '_blank'
            );
          }}
        >
          SAFETY
        </span>
      </div> */}
      <List>
        {sidebarItems.map((menuItemList, index) => (
          <>
            {index !== 0 && <Divider sx={{ margin: '1px 0px' }} />}
            {menuItemList.map((menuItem) => (
              <ListItem
                key={menuItem.text}
                disablePadding
                sx={{
                  transition: 'all 0.15s ease-in-out',
                  background:
                    location &&
                    menuItem.activePath &&
                    location.pathname === menuItem.activePath
                      ? 'rgba(33, 150, 243, 0.08)'
                      : 'white',
                  '&:hover': {
                    background:
                      location &&
                      menuItem.activePath &&
                      location.pathname === menuItem.activePath
                        ? 'rgba(33, 150, 243, 0.08)'
                        : 'rgba(0, 37, 71, 0.04)',
                  },
                }}
                onClick={menuItem.action}
              >
                <ListItemButton
                  sx={{
                    backgroundColor: 'transparent',
                    '&:hover': { backgroundColor: 'transparent' },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: '48px' }}>{menuItem.icon}</ListItemIcon>
                  <ListItemText
                    primary={menuItem.text}
                    sx={{
                      '.MuiTypography-root': {
                        color: 'rgba(0, 37, 71, 0.87) !important',
                        fontSize: '16px',
                        fontWeight: '400',
                        lineHeight: '24px',
                        letterSpacing: '0.15px',
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </>
        ))}
      </List>
    </Box>
  );

  return (
    <StyledAppBar
      component='header'
      position='relative'
      onClickMenu={handleDrawerToggle}
      brandLogo={
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {sidebarItems && sidebarItems.length > 0 && (
            <Menu
              sx={{
                color: '#002547',
                fontSize: '16px',
                height: '32px !important',
                width: '32px !important',
                cursor: 'pointer',
              }}
              onClick={toggleMenu(true)}
            ></Menu>
          )}
          <img
            src={bmpoLogo}
            alt='BMPO'
            style={{ height: '13.54px', cursor: 'pointer' }}
            onClick={() => {
              toggleMenu(false);
              navigate(ROUTE_PATHS.HOME);
            }}
          />
          
        </div>
      }
      sx={{ '.MuiToolbar-regular img': { width: 'auto' } }}
    >
      <Hidden mdUp>
        <DrawerMenu drawerOpen={drawerOpen} handleDrawerToggle={handleDrawerToggle} />
      </Hidden>

      <StyledDivider orientation='vertical' flexItem light></StyledDivider>
      
      <NavigationMenu />
      <Button
        variant='contained'
        color='primary'
        size='medium'
        sx={{
          marginRight: '16px',
          textTransform: 'none',
          width: '180px',
          minWidth: '180px',
          maxWidth: '180px',
          padding: '4px 32px',
          height: '32px',
          whiteSpace: 'nowrap',
          borderRadius: '4px',
          fontSize: '13px',
          fontWeight: '500',
          lineHeight: '22px',
          letterSpacing: '0',
          boxShadow:
            '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important',

        }}
        onClick={() => {
          // Add PowerBI dashboard URL here
         navigate(ROUTE_PATHS.POWERBI);
        }}
      >
        View Power BI Dashboard
      </Button>
      <Grid container item xs justifyContent='flex-end'>
        <UserMenu />
      </Grid>
      
      {sidebarItems && sidebarItems.length > 0 && (
        <Drawer
          open={menuOpen}
          onClose={toggleMenu(false)}
          disableEnforceFocus
          disableRestoreFocus
          sx={{
            zIndex: '1350',
            '.MuiPaper-root:focus-visible': {
              outline: 'none !important',
              boxShadow: 'none !important',
              borderRadius: '0px',
            },
            '.MuiBox-root': {
              width: '320px',
            },
          }}
        >
          {DrawerList}
        </Drawer>
      )}
      
    </StyledAppBar>
  );
}
